window.mx = window.mx || {};

window.mx.MxBackInStockGrid = class extends window.mx.MxSection {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('BIS grid connected');

    this.cardList.forEach((card) => {
      const BISButton = card.querySelector('button');
      this.eventManager.addListener(BISButton, 'click', () => this.onBISButtonClick(card));
    });
  }

  get cardList() {
    return this.querySelectorAll('.bis-product-container');
  }

  onBISButtonClick(card) {
    console.log(card.querySelector('script').textContent);

    const variantDataJson = JSON.parse(card.querySelector('script').textContent);

    console.log(variantDataJson);

    if (!BIS) {
      console.error('Back In Stock not loaded');
      return false;
    }

    BIS.Config.product = variantDataJson;

    BIS.popup = BIS.createPopover();
    BIS.popup?.toggle();
    BIS.popup?.form?.frame?.contentDocument?.querySelector('.action-close')?.style?.setProperty('display', 'block');
    BIS.popup?.form?.frame?.contentDocument?.querySelector('#variants')?.querySelectorAll('option')?.forEach((option) => {
      if (option.textContent.startsWith('Réservation')) {
        option.remove();
      }
    });
  }
};
if (!window.customElements.get('mx-back-in-stock-grid'))
  window.customElements.define('mx-back-in-stock-grid', window.mx.MxBackInStockGrid);
